import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import { useSearchParams} from "react-router-dom";
import axios from 'axios';
import { config, KeyUri } from '../key';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import Bookingpdf from './Bookingpdf'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import {storage} from '../firebaseconfig';
import { Buffer } from "buffer";

window.Buffer = Buffer;

const BookingConfirmed = () => {


  const location = useLocation();
//  const { paymentId, rideid } = location.state || {};
// const queryParams = new URLSearchParams(location.search);
//const paymentId = queryParams.get('paymentId');
//const rideid = queryParams.get('rideid');
  const [searchParams] = useSearchParams();

  const paymentIdFromState = location.state?.paymentId;
const rideIdFromState = location.state?.rideid;

  const paymentId = searchParams.get('paymentId')  || paymentIdFromState;
  const rideid = searchParams.get('rideid')|| rideIdFromState;

   const componentKey = `${paymentId}-${rideid}`;

  const [booking_details, set_booking_details] = useState({})
  const [payment_details, set_payment_details] = useState({})

  const [loading, setLoading] = useState(true);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  const gateway = searchParams.get('gateway') || 'razorpay';

  //const [isDataReady, setIsDataReady] = useState(false);

/*useEffect(() => {
  const queryParams = new URLSearchParams(window.location.search);
  const hasReloaded = queryParams.get('forceReload');

  if (!hasReloaded && paymentId && rideid) {
    queryParams.set('forceReload', 'true');
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.location.replace(newUrl); // Replace avoids back-button issues
  }
}, [paymentId, rideid]);*/
 
/*useEffect(() => {
    // Check if the page has already been reloaded this session
    if (!sessionStorage.getItem('hasRefreshed')) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
    }
    // If already refreshed, do nothing
  }, []);*/

  useEffect(() => {
   
  }, [paymentId, rideid, location.search]);


  
  useEffect(() => {
    if (!paymentId || !rideid) {
      //setError("Missing booking parameters.");
      setLoading(false);
      return;
    }
    setLoading(true);
    //setError(null);

      const fetchPaymentDetails = async () => {
      if (!paymentId || !rideid) return;

      try {
        const token = JSON.parse(localStorage.getItem("tokenUser"));

        // ── HDFC: booking is already fully updated by processHdfcPayment ──
        if (gateway === 'hdfc') {
          const received_data = await axios.get(`${KeyUri.BACKEND_URI}/get-booking/${rideid}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          const bookingData = received_data?.data;
          set_booking_details(bookingData);

          const paymentData = {
            status: bookingData?.payment_status === "captured" ? "captured" : bookingData?.payment_status,
            amount: bookingData?.payment_amount,
            method: "hdfc",
            created_at: bookingData?.payment_date
              ? Math.floor(new Date(bookingData.payment_date).getTime() / 1000)
              : Math.floor(Date.now() / 1000),
          };
          set_payment_details(paymentData);

                    if (paymentData.status !== "captured") {
            setLoading(false);
            return;
          }
          
          const blob = await pdf(
            <Bookingpdf invoiceData={bookingData} payment={paymentData} paymentAmount={paymentData.amount} />
          ).toBlob();

          const fileRef = ref(storage, `booking-pdfs/booking_${rideid}.pdf`);
          const uploadResult = await uploadBytes(fileRef, blob);
          await getDownloadURL(uploadResult.ref);

          await axios.post(`${KeyUri.BACKEND_URI}/bookingalert`, { booking_idd: rideid }, {
            headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
          });
          await axios.post(`${KeyUri.BACKEND_URI}/sendinvoice`, { booking_idd: rideid }, {
            headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
          });

          setLoading(false);
          return;
        }
        let paymentData;

        if (gateway === 'cashfree') {
          const cfResponse = await axios.get(
            `${KeyUri.BACKEND_URI}/payment/check-cashfree-payment/${paymentId}`,
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          // Normalize Cashfree's shape to match what this component expects
          paymentData = {
            status: cfResponse.data.status === "PAID" ? "captured" : cfResponse.data.status,
            amount: cfResponse.data.amount,
            method: "cashfree",
            created_at: Math.floor(Date.now() / 1000),
          };
        } else {
          const response = await axios.get(
            `${KeyUri.BACKEND_URI}/payment/check-payment/${paymentId}`,
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          paymentData = response?.data;
        }

        set_payment_details(paymentData);
        // Step 2: Fetch booking details
        const received_data = await axios.get(`${KeyUri.BACKEND_URI}/get-booking/${rideid}`,   {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
        set_booking_details(received_data?.data);
  
        // Step 3: Update booking with payment details
        const values = {
          payment_status: paymentData.status,
          payment_method: paymentData.method,
          payment_amount: paymentData.amount,
          payment_date: new Date(paymentData.created_at * 1000),
          payment_id: paymentId
        };
        await axios.put(`${KeyUri.BACKEND_URI}/update-booking/${rideid}`, values,   {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
       
       // Delay 500ms before fetching updated booking data
await new Promise(resolve => setTimeout(resolve, 500)); 
  // Fetch fresh updated booking details after update completes
const updatedBookingResponse = await axios.get(`${KeyUri.BACKEND_URI}/get-booking/${rideid}`, {
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
});
const updatedBookingData = updatedBookingResponse?.data;
set_booking_details(updatedBookingData);
        // Step 4: Generate and upload PDF
        const blob = await pdf(
          <Bookingpdf invoiceData={updatedBookingData} payment={paymentData} paymentAmount={paymentData.amount}/>
        ).toBlob();
       

  
        const fileRef = ref(storage, `booking-pdfs/booking_${rideid}.pdf`);
        const uploadResult = await uploadBytes(fileRef, blob);
        const downloadURL = await getDownloadURL(uploadResult.ref);
        
  
        // Step 5: Now send alert and invoice link AFTER updating and uploading
        await axios.post(`${KeyUri.BACKEND_URI}/bookingalert`, { booking_idd: rideid }, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
        await axios.post(`${KeyUri.BACKEND_URI}/sendinvoice`, { booking_idd: rideid }, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
   
         //setIsDataReady(true);
         setLoading(false);
      } catch (e) {
        console.error("Error fetching booking/payment data:", e);
       // setError("Failed to load booking details. Please refresh or try again later.");
        setLoading(false);
      }
    };
  
    fetchPaymentDetails();
   

  }, [paymentId, rideid]);

   /* const handleDownloadPDF = async () => {
       console.log("Download Invoice button clicked");
    console.log("Current booking details:", booking_details);
    console.log("Current payment details:", payment_details);

      if (loading || !booking_details?.userid || !payment_details?.status) {
    alert('Invoice is still loading. Please wait.');
    return;
  }
  const safePaymentAmount = Number(payment_details.amount)  ?? 0;
    const blob = await pdf(<Bookingpdf invoiceData={booking_details} payment={payment_details} paymentAmount={safePaymentAmount}/>).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = "Booking_Confirmation.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    console.log("Booking details payment amount:", booking_details?.amount);

  }; */

  const handleDownloadPDF = async () => {
  if (loading || !booking_details?.userid || !payment_details?.status) {
    alert('Invoice is still loading. Please wait.');
    return;
  }

  try {
    setIsGeneratingPdf(true);

    const safePaymentAmount = Number(payment_details.amount) || 0;
    const blob = await pdf(
      <Bookingpdf invoiceData={booking_details} payment={payment_details} paymentAmount={safePaymentAmount} />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = "Booking_Confirmation.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to generate invoice PDF:", error);
    alert("Failed to generate invoice PDF. Please try again.");
  } finally {
    setIsGeneratingPdf(false);
  }
};

  
  
  const date_in_normal_form = (rideDate) => {
    // Convert the rideDate string to a Date object
    const rideDateObj = new Date(rideDate);

    // Options to format the date
    const options = {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };

    // Format the date to the desired format "Sunday, dd-mm-yyyy"
    const formattedDate = rideDateObj
      .toLocaleDateString("en-GB", options)
      .replace(",", " - ");

    return formattedDate;
  };
 /* const handleDownloadPDF = async () => {
    console.log("all booking details " + booking_details)
    const blob = await pdf(<Bookingpdf invoiceData={booking_details} payment={payment_details} />).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = "Booking_Confirmation.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
*/
  return (
    
    <div key={componentKey}>
      {(paymentId || rideid) ? <div className="min-h-screen bg-gray-50 mb-16" key={`${paymentId}-${rideid}`}>
        <div className="bg-green-50 p-4 border-b border-green-200">



          {((payment_details?.status === "captured") ? <div className="max-w-4xl mx-auto flex items-center gap-2 text-green-700 content-center ">
            <span>Booking Confirmed Successfully!</span>
          </div> : <div className="max-w-4xl mx-auto flex items-center gap-2 text-red-700">
            <span>Payment Under Process</span>
          </div>)}

        </div>
       
        <div className="max-w-4xl mx-auto p-4 sm:p-6 lg:p-8 space-y-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center mt-4 justify-between gap-4">
            <h1 className="text-2xl font-semibold">Booking Details

            </h1>
          </div>
          <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-lg font-medium mb-4">Main Passenger Details</h2>
              <div className="space-y-2">
                
                <div><span className="font-medium">Name: </span>{booking_details?.userid?.name}</div>
                <div><span className="font-medium">Email: </span>{booking_details?.userid?.email}</div>
                <div><span className="font-medium">Phone: </span> {booking_details?.userid?.phone_number}</div>
              </div>
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-4 py-5 sm:p-6">
                <h2 className="text-lg font-medium mb-4">Journey Details</h2>
                <div className="space-y-2">
                  <div><span className="font-medium">From:</span> {booking_details?.route?.from_location?.name}</div>
                  <div><span className="font-medium">To:</span> {booking_details?.route?.to_location?.name}</div>
                  <div><span className="font-medium">Date of Trip: </span>{date_in_normal_form(booking_details?.ride_date_and_time)}</div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-4 py-5 sm:p-6">
                <h2 className="text-lg font-medium mb-4">Location Details</h2>
                <div className="space-y-2">
                  <div><span className="font-medium">Pickup:</span> {booking_details?.pickup_point}</div>
                  <div><span className="font-medium">Drop:</span>  {booking_details?.drop_point}</div>
                  <div><span className="font-medium">Seats Booked:</span> {booking_details?.selected_seats?.join(" , ")}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-lg font-medium mb-6">Vehicle Details</h2>
              <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-2">
                <div className="relative h-48 w-full">
                  <img
                    src={booking_details?.vehicleId?.picture_of_the_vehicle}
                    alt="Toyota Innova"
                    className="rounded-lg object-cover h-full w-full"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-4">{booking_details?.data?.vehicleId?.brand_name} {booking_details?.data?.vehicleId?.model_name}</h3>
                  <ul className="space-y-2">
                    <li>• Air Conditioned Luxury Vehicle</li>
                    <li>• Comfortable & Spacious Seating</li>
                    <li>• Female Passenger Safety Standards</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-indigo-50 shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center justify-between">
                <span className="text-lg font-medium">Total Amount Paid:</span>
                <span className="text-2xl font-semibold">₹ {(payment_details?.amount)}/-</span>
              </div>
            </div>
          </div>
          {/* <div className="bg-indigo-50 shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center justify-between">
                <span className="text-lg font-medium">
                  Ride has been booked, and driver details will be shared 24 hours before the ride begins.
                </span>   
                         
                </div>
            </div>
          </div> */}
          <div className="bg-indigo-50 shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center justify-between">
               {(payment_details?.status==="captured" ? <span className="text-lg font-medium">
                  Ride has been booked, and driver details will be shared 24 hours before the ride begins.
                </span> : <span className="text-lg font-medium">
                  Payment Under Process
                </span>  )} 
                         
                </div>
            </div>
          </div>
          <button 
              onClick={handleDownloadPDF} 
              className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg"
              disabled={loading|| isGeneratingPdf}
            >

             {loading || isGeneratingPdf? "Preparing Invoice..." : "Download Invoice"}
            </button>
            <p className="mt-1 text-sm text-gray-500">
  If you are unable to download the invoice, please refresh the page once to generate.
</p>

        </div>
      </div> : <h1>You are Not allowed To View This page</h1>}

    </div>
  )
}

export default BookingConfirmed;
